import { PropTypes } from 'prop-types'
import { apis } from '../api/apiUrl'
export const DecodeHtml = ({ html }) => {
  html = html?.replace(/<img src="\/media/g, `<img src="${apis.base_url}media`)
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      className=' flex flex-col'
      style={{
        whiteSpace: 'wrap'
      }}
    ></div>
  )
}
DecodeHtml.propTypes = {
  html: PropTypes.string
}
